import loadable from '@loadable/component'
import * as React from 'react'
import { Props } from 'react-modal'

const LazyModal = loadable(async () => {
  const Module = await import(`react-modal`)
  const Modal = Module.default

  let rootElement = {} as HTMLElement | null
  const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement => input !== null && input.tagName === 'IFRAME'
  if (typeof window !== `undefined`) {
    rootElement = document.getElementById('___gatsby')
    if (!rootElement) {
      const iframe = document.getElementById('preview-pane')
      if (isIFrame(iframe) && iframe.contentWindow) {
        rootElement = iframe.contentWindow.document.body
      }
    }
    if (rootElement) {
      Modal.setAppElement(rootElement)
    }
  }

  return (props: Props) => <Modal parentSelector={(rootElement && (() => rootElement as HTMLElement)) || undefined} {...props} />
})

export default LazyModal
